<!--
대금상환 창고지급취소 팝업 (TASK-161 §0-5 — 라운드 ⓒ · 라벨 결정 30)
------------------------------------
 - 페이지당 1 인스턴스. 행 「창고지급취소」 버튼이 open(row) 로 데이터 주입
 - 비워질 값 (창고지급(실제) · 창고지급일) + 유지 값 (창고지급비고 — 결정 4) 텍스트 표시 + 사유 textarea 필수 (공란이면 확인 버튼 disabled)
 - 확인 → PATCH /regions/{regionId}/cod-payments/{id}/unpaid
 - 사이클 16 #27: 상단 = 공용 컨텍스트 헤더 app-buy-order-ctx (대금상환금액 큰 글자 · 창고지급(실제) · 창고지급일)
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-unpaid-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">대금상환 창고지급취소</h3>

            <!-- 사이클 16 #27 — 컨텍스트 헤더 (공용 app-buy-order-ctx: 해외오더번호 · 트래킹 칩 · 대금상환금액 큰 글자 · 창고지급(실제) · 창고지급일) -->
            <app-buy-order-ctx v-if="row" :code="row.buy_order_code || ''" :trackings="row.tracking_nos || []" :items="ctxItems"></app-buy-order-ctx>

            <!-- 사이클 16 (사용자): 주황 경고 박스 폐지 — 안내 1줄 + 유지되는 비고만 (창고지급(실제) · 창고지급일은 위 컨텍스트 헤더에 이미 표시) -->
            <div class="cdp-unpaid-note uk-text-muted" v-if="row">
                <div>창고지급취소하면 <b>요청</b> 상태로 돌아가고 창고지급(실제) · 창고지급일이 비워집니다. 창고지급비고는 유지됩니다.</div>
                <div class="cdp-pre" v-if="row.paid_memo">창고지급비고 (유지) : {{ row.paid_memo }}</div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label">창고지급취소 사유 (필수)</label>
                <div class="uk-form-controls">
                    <textarea class="uk-textarea cdp-unpaid-reason" rows="3" v-model="inputReason" placeholder="창고지급취소 사유를 입력하세요"></textarea>
                </div>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-danger cdp-unpaid-submit" type="button" :disabled="busy || ! hasReason" @click="submit">창고지급취소 확인</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from './popup-mixin';

    export default {
        mixins: [CodPopupMixin],
        props: {
            // csrf-token
            csrfToken: String,

            // 센터ID (라우트)
            regionId: [String, Number],
        },
        data: function () {
            return {
                inputReason: '',
            };
        },
        computed: {
            // 컨텍스트 헤더 키-값 (사이클 16 #27)
            ctxItems() {
                if (! this.row) {
                    return [];
                }
                return [
                    {k: '대금상환금액', v: this.reqAmountText, big: true},
                    {k: '창고지급(실제)', v: this.paidAmountText},
                    {k: '창고지급일', v: this.row.paid_at || '-'},
                ];
            },

            hasReason() {
                return this.inputReason.trim() !== '';
            },
        },
        methods: {
            open(row) {
                this.row = row || null;
                this.inputReason = '';
                this.show();
            },

            submit() {
                if (this.busy || ! this.row || ! this.hasReason) {
                    return;
                }
                this.request('patch', '/regions/' + this.regionId + '/cod-payments/' + this.row.id + '/unpaid', {
                    reason: this.inputReason.trim(),
                }).then(this.done);
            },
        },
    }
</script>

<style scoped>
    .cdp-pre {
        white-space: pre-wrap;
    }
</style>
